const track = (data) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push(data);
};

const trackCube = (data) => {
  if (!window.CubeDataLayer) {
    window.CubeDataLayer = [];
  }
  window.CubeDataLayer.push(data);
};

const trackCubePageViewGiftCard = () =>
  trackCube({
    event_name: 'page_view',
    responsible_team_tracking: 'ENTS',
    event_data: {
      page_type: 'detail_product',
      page_content: ['giftcard'],
      is_interaction_event: true,
    },
  });

const trackCubePageViewPds = () =>
  trackCube({
    event_name: 'page_view',
    responsible_team_tracking: 'ENTS',
    event_data: {
      page_type: 'detail_product',
      page_content: ['product'],
      is_interaction_event: true,
    },
  });

export const trackClickAndReserveEvent = () =>
  trackCube({
    event_name: 'hva_open',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS', // optional
    event_data: {
      event_category: 'click_and_reserve',
      is_interaction_event: true,
      event_type: 'click',
      event_context: 'pds_link',
    },
  });

const trackCubeCustomEvent = (eventName, eventData, items) =>
  trackCube({
    event_name: eventName,
    responsible_team_tracking: 'ENTS',
    event_data: {
      ...eventData,
      ...(eventName === 'ab_test' && { event_duration: 'temporary' }),
    },
    ...(items !== undefined && { items: items }),
  });

const trackProductView = (details) => {
  trackCube({
    ...details,
    event_name: 'product_view',
    responsible_team_tracking: 'ENTS',
  });
};

const trackRecoView = (details) => {
  trackCube({
    event_name: 'reco_view',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    ...details,
  });
};

const trackRecoClick = (details) => {
  trackCube({
    event_name: 'reco_click',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    ...details,
  });
};

const trackSizeSelected = (syan, articleId, salesInformationId, colorId, isOutOfStock, eventContext) => {
  trackCube({
    event_name: 'size_selected',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    event_data: {
      event_category: 'size_layer',
      is_interaction_event: true,
      event_type: 'click',
      event_context: eventContext ?? 'size_menu',
    },
    items: [
      {
        ...(colorId ? { farb_id: colorId } : {}),
        artikel_id: articleId,
        vertriebsinfo_id: salesInformationId,
        syan: syan.toString(),
        is_sponsored: false,
        is_available: !isOutOfStock,
      },
    ],
  });
};

const trackPdpElementSeen = (eventContent) => {
  trackCube({
    event_name: 'pdp_element_seen',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS', // optional
    event_data: {
      event_category: 'product_details',
      is_interaction_event: false,
      event_type: 'view',
      event_content: [eventContent],
    },
  });
};

const trackClassicGiftcardLink = () => {
  trackCube({
    event_name: 'link_click',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    event_data: {
      event_category: 'product_details',
      is_interaction_event: true,
      event_type: 'click',
      event_context: 'giftcard',
      event_content: ['buy_classic_giftcard'],
    },
  });
};

const trackAbTestSeen = (testName, decisionId) => {
  trackCube({
    event_name: 'pb_info',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    event_data: {
      event_context: testName,
      pb_impression: decisionId,
    },
  });
};

const trackAbTestClicked = (testName, decisionId) => {
  trackCube({
    event_name: 'pb_info',
    responsible_team_tracking: 'ENTS',
    responsible_team_feature: 'ENTS',
    event_data: {
      event_context: testName,
      pb_click: decisionId,
    },
  });
};

export {
  track,
  trackProductView,
  trackRecoView,
  trackRecoClick,
  trackCubeCustomEvent,
  trackCubePageViewPds,
  trackCubePageViewGiftCard,
  trackSizeSelected,
  trackPdpElementSeen,
  trackClassicGiftcardLink,
  trackAbTestSeen,
  trackAbTestClicked,
};
